import React from 'react';
import { openCookiePreferences } from '../lib/consent';

function Footer({ onOpenDataSecurityModal }) {
  const apiBase =
    process.env.REACT_APP_API_BASE ||
    process.env.REACT_APP_API_BASE_URL ||
    'http://localhost:3001';
  const advUrl =
    process.env.REACT_APP_ADV_URL || `${apiBase.replace(/\/$/, '')}/api/adv/download`;
  const disclosureText = "Bautista Planning and Analytics, LLC is a registered investment advisor with the State of Oregon. All views, expressions, and opinions included in this communication are subject to change. This communication is not intended as an offer or solicitation to buy, hold or sell any financial instrument or investment advisory services. Any information provided has been obtained from sources considered reliable, but we do not guarantee the accuracy, or the completeness of, any description of securities, markets or developments mentioned. We may, from time to time, have a position in the securities mentioned and may execute transactions that may not be consistent with this communication's conclusions. Please contact us at 458-227-9655 if there is any change in your financial situation, needs, goals or objectives, or if you wish to initiate any restrictions on the management of the account or modify existing restrictions. Additionally, we recommend you compare any account reports from BPA with the account statements from your Custodian. Please notify us if you do not receive statements from your Custodian on at least a quarterly basis. Our current disclosure brochure, Form ADV Part 2, is available for your review upon request, and on our website, www.bautistaplanningandanalytics.com. This disclosure brochure, or a summary of material changes made, is also provided to our clients on an annual basis.";

  return (
    <footer style={{
      width: '100%',
      padding: '20px 0',
      backgroundColor: '#f8f9fa', // Light background
      color: '#6c757d', // Muted text color
      textAlign: 'center',
      fontSize: '0.9em',
      borderTop: '1px solid #e9ecef',
      marginTop: 'auto', // Pushes footer to the bottom if content is short
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        gap: '20px',
        flexWrap: 'wrap'
      }}>
        {onOpenDataSecurityModal ? (
          <button onClick={onOpenDataSecurityModal} style={{ background: 'none', border: 'none', color: '#6c757d', cursor: 'pointer', fontSize: 'inherit', padding: 0 }}>Data Privacy & Security</button>
        ) : null}
        <a href={advUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#6c757d', textDecoration: 'none' }}>Download My ADV</a>
        <a href="/privacy-policy" style={{ color: '#6c757d', textDecoration: 'none' }}>Privacy Policy</a>
        <a href="/terms-of-use" style={{ color: '#6c757d', textDecoration: 'none' }}>Terms of Use</a>
        <button type="button" onClick={openCookiePreferences} style={{ background: 'none', border: 'none', color: '#6c757d', cursor: 'pointer', fontSize: 'inherit', padding: 0 }}>Cookie Preferences</button>
        <a href="mailto:joe@bautistaplanningandanalytics.com?subject=Financial App Support Request" style={{ color: '#6c757d', textDecoration: 'none' }}>Contact Support</a>
      </div>
      <p style={{
        maxWidth: '1000px',
        margin: '15px auto 0',
        padding: '0 16px',
        color: '#6c757d',
        fontSize: '0.82em',
        lineHeight: 1.5,
        textAlign: 'left'
      }}>
        {disclosureText}
      </p>
      <p style={{ margin: '15px 0 0 0' }}>&copy; {new Date().getFullYear()} Bautista Planning and Analytics. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
